<template>
  <div class="mesJustificatifsPage-container col-sm-12">
    <div class="mesJustificatifsPage">
      <div
        v-if="submitted && erreurMesJustificatifs != null"
        class="alert alert-danger text-left global-errors"
      >
        <p>
          {{ erreurMesJustificatifs }}
        </p>
      </div>

      <div
        v-if="erreurGlobale != null"
        class="alert alert-danger text-left global-errors mb-5"
      >
        <p>
          {{ erreurGlobale }}
        </p>
      </div>

      <!-- APTITUDES -- on affiche pas le bloc si aucune fonction récupérée -->
      <div
        v-if="
          preinscription_out.data.licence.fonctionsNiveaux != null &&
            preinscription_out.data.licence.fonctionsNiveaux.length != 0
        "
      >
        <div class="row title mt-4">
          {{ "mes_justificatifs_aptitudes" | translate(locale) }}
        </div>
        <p class="mes-justificatifs-text mt-3">
          {{ "mes_justificatifs_aptitudes_text_1" | translate(locale) }}
        </p>
        <p
          class="mes-justificatifs-text"
          style="font-style:italic; margin-left: 25px"
          v-for="fonctionNiveau in preinscription_out.data.licence
            .fonctionsNiveaux"
          :key="fonctionNiveau.index"
        >
          {{ fonctionNiveau.fonction.libelle }} -
          {{ fonctionNiveau.niveau.libelle }}
        </p>

        <p class="mes-justificatifs-text mt-3">
          {{ "mes_justificatifs_aptitudes_text_2" | translate(locale) }}
          {{ this.preinscription_out.data.saison.debut.substring(0, 4) }}
          {{ "mes_justificatifs_aptitudes_text_3" | translate(locale) }}
          {{ this.preinscription_out.data.saison.libelle.toLowerCase() }}.
        </p>
      </div>

      <!-- JUSTIFICATIFS -->
      <div class="row title mt-5">
        {{ "mes_justificatifs_justificatifs" | translate(locale) }}
      </div>

      <div v-if="listeJustificatifs && listeJustificatifs.length > 0">
        <p class="mes-justificatifs-text mt-3 mb-3">
          {{ "mes_justificatifs_justificatifs_text" | translate(locale) }}
        </p>
        <p
          v-if="getAgeParDateCourante() < 18"
          class="mes-justificatifs-text mt-3 mb-3"
        >
          {{
            "mes_justificatifs_justificatifs_text_mineur" | translate(locale)
          }}
        </p>
        <div class="mes-justificatifs">
          <carte-identite-modale
            v-if="
              listeJustificatifs.filter(j => j.type === 'CARTE_IDENTITE')
                .length > 0
            "
            :token="token_out"
            :preinscription="preinscription"
            v-on:getCarteIdentiteAcceptee="getCarteIdentiteAcceptee"
          >
          </carte-identite-modale>

          <surclassement-modale
            v-if="
              listeJustificatifs.filter(j => j.type === 'SURCLASSEMENT')
                .length > 0
            "
            :token="token_out"
            :preinscription="preinscription"
            :preinscription_out="this.preinscription_out"
            :isCertificatIdentiqueSurclassement="
              this.preinscription_out.data.informationMedicale
                .certificatIdentiqueSurclassement
            "
            v-on:getSurclassementAcceptee="getSurclassementAcceptee"
          ></surclassement-modale>

          <certificat-medical-modale
            v-if="
              listeJustificatifs.filter(j => j.type === 'CERTIFICAT_MEDICAL')
                .length > 0
            "
            :token="token_out"
            :preinscription="preinscription"
            :preinscription_out="this.preinscription_out"
            :isPresent="
              listeJustificatifs.filter(j => j.type === 'CERTIFICAT_MEDICAL')[0]
                .present
            "
            :isQuestionnaireSanteReponsePositive="
              isQuestionnaireSanteReponsePositive
            "
            v-on:getCertificatMedicalAcceptee="getCertificatMedicalAcceptee"
          >
          </certificat-medical-modale>

          <charte-engagement-modale
            v-if="
              listeJustificatifs.filter(j => j.type === 'CHARTE_ENGAGEMENT')
                .length > 0
            "
            :nom-licencie="preinscription_out.data.nom"
            :prenom-licencie="preinscription_out.data.prenom"
            :isPresent="
              listeJustificatifs.filter(j => j.type === 'CHARTE_ENGAGEMENT')[0]
                .present
            "
            v-on:getCharteEngagementAcceptee="getCharteEngagementAcceptee"
          ></charte-engagement-modale>

          <questionnaire-sante-modale
            v-if="
              listeJustificatifs.filter(j => j.type === 'QUESTIONNAIRE_SANTE')
                .length > 0
            "
            :preinscription="preinscription"
            :isPresent="this.isQuestionnaireSantePresent"
            v-on:getQuestionnaireSanteAcceptee="getQuestionnaireSanteAcceptee"
          >
          </questionnaire-sante-modale>
        </div>
        <div>
          <p
            class="text-center mes-justificatifs-text mt-4"
            style="font-style: italic"
          >
            {{ "mes_justificatifs_justificatifs_text_2" | translate(locale) }}
          </p>
        </div>
      </div>

      <div v-if="listeJustificatifs && listeJustificatifs.length === 0">
        <p class="mes-justificatifs-text mt-3 mb-3">
          {{ "mes_justificatifs_justificatifs_text_3" | translate(locale) }}
        </p>
      </div>

      <div
        v-if="submitted && erreurMesJustificatifs != null"
        class="alert alert-danger text-left global-errors mt-5"
      >
        <p>
          {{ erreurMesJustificatifs }}
        </p>
      </div>

      <div
        v-if="alerteCertificatMedical != null"
        class="alert alert-danger text-left global-errors mt-3"
      >
        <p>
          {{ alerteCertificatMedical }}
        </p>
      </div>

      <div
        v-if="erreurGlobale != null"
        class="alert alert-danger text-left global-errors mb-5"
      >
        <p>
          {{ erreurGlobale }}
        </p>
      </div>

      <div
        v-if="this.preinscription.data.erreurs.length != 0"
        class="alert alert-danger text-left global-errors mt-3"
      >
        <p
          v-for="erreur in this.preinscription.data.erreurs"
          :key="erreur.index"
        >
          {{ erreur.message }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SurclassementModale from "@/components/general/SurclassementModale.vue";
import CarteIdentiteModale from "@/components/general/CarteIdentiteModale.vue";
import CharteEngagementModale from "@/components/general/CharteEngagementModale.vue";
import CertificatMedicalModale from "@/components/general/CertificatMedicalModale.vue";
import QuestionnaireSanteModale from "@/components/general/QuestionnaireSanteModale.vue";
import preinscriptionAppelsServeur from "@/preinscriptionUtils";
import translations from "@/Translations.js";
import _ from "lodash";

export default {
  components: {
    SurclassementModale,
    CarteIdentiteModale,
    CharteEngagementModale,
    CertificatMedicalModale,
    QuestionnaireSanteModale
  },
  props: {
    preinscription: Object,
    token: undefined,
    locale: {
      type: String,
      default: "fr"
    }
  },
  data() {
    return {
      preinscription_out: Object,
      listeJustificatifs: undefined,
      erreurMesJustificatifs: null,
      erreurGlobale: null, // valorisée dans traitementErreursServeur
      alerteCertificatMedical: null,
      isQuestionnaireSantePresent: null,
      isQuestionnaireSanteReponsePositive: false,
      submitted: false,
      token_out: undefined
    };
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  watch: {
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    },
    listeJustificatifs: {
      handler: function() {
        this.validationPage();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    canContinue() {
      this.submitted = true;
      // les document sont déja sauvegardés dans la base, avant la validation, par le ws putDocument
      this.preinscription_out.data.document = this.preinscription.data.document;
      this.validationPage();
    },
    validationPage() {
      this.erreurMesJustificatifs = null;
      // si les justificatifs ne sont tous fournis et validés, on peut pas continuer
      if (
        _.some(this.listeJustificatifs, function(justificatif) {
          return (
            justificatif.type != "QUESTIONNAIRE_SANTE" && !justificatif.present
          );
        })
      ) {
        this.erreurMesJustificatifs =
          "Vous devez fournir tous les justificatifs demandés ci-dessus";
        this.$emit("can-continue", { value: false });
      } else if (
        this.isQuestionnaireSantePresent != null &&
        _.some(this.listeJustificatifs, function(justificatif) {
          return (
            justificatif.type == "QUESTIONNAIRE_SANTE" && !justificatif.present
          );
        })
      ) {
        this.erreurMesJustificatifs =
          "Vous devez répondre au questionnaire de santé";
        this.$emit("can-continue", { value: false });
      } else {
        this.$emit("can-continue", {
          value: true,
          preinscription: this.preinscription_out
        });
      }
    },
    getCharteEngagementAcceptee(isConditionAcceptee) {
      // on met a jour dans la liste des justificatifs le champ 'present'
      // on peut passer a la page suivante seulement si tous les documents ont été chargés/validés
      let justificatifCharteEngagement = _.find(this.listeJustificatifs, {
        type: "CHARTE_ENGAGEMENT"
      });
      if (justificatifCharteEngagement) {
        justificatifCharteEngagement.present = isConditionAcceptee;
      }
    },
    getQuestionnaireSanteAcceptee(isConditionAcceptee) {
      if (isConditionAcceptee) {
        // on doit forcément repasser la case du certificat médical à non fourni
        let justificatifCertificatMedical = _.find(this.listeJustificatifs, {
          type: "CERTIFICAT_MEDICAL"
        });
        if (justificatifCertificatMedical) {
          justificatifCertificatMedical.present = false;
          this.isQuestionnaireSantePresent = null;
          this.isQuestionnaireSanteReponsePositive = true;

          this.alerteCertificatMedical =
            "Les réponses que vous avez donné dans le questionnaire de santé, vous imposent de refournir un nouveau certificat médical";
        }
      } else {
        this.isQuestionnaireSantePresent = true;
        let justificatifQuestionnaireSante = _.find(this.listeJustificatifs, {
          type: "QUESTIONNAIRE_SANTE"
        });
        if (justificatifQuestionnaireSante) {
          justificatifQuestionnaireSante.present = true;
        }
      }
    },
    getCertificatMedicalAcceptee(isConditionAcceptee) {
      // on met a jour dans la liste des justificatifs le champ 'present'
      // on peut passer a la page suivante seulement si tous les documents ont été chargés/validés
      let justificatifCertificatMedical = _.find(this.listeJustificatifs, {
        type: "CERTIFICAT_MEDICAL"
      });
      if (justificatifCertificatMedical) {
        justificatifCertificatMedical.present = isConditionAcceptee;
        this.alerteCertificatMedical = null;
        this.isQuestionnaireSanteReponsePositive = false;
      }

      // si la date du certificat a été modifiée -> le questionnaire de santé doit toujours passer en 'non demandé'
      if (
        isConditionAcceptee &&
        this.preinscription.data.informationMedicale.dateCertificatMedical !=
          this.preinscription_out.data.informationMedicale.dateCertificatMedical
      ) {
        this.isQuestionnaireSantePresent = null;
      }
    },
    getCarteIdentiteAcceptee(isConditionAcceptee) {
      let justificatifCarteIdentite = _.find(this.listeJustificatifs, {
        type: "CARTE_IDENTITE"
      });
      if (justificatifCarteIdentite) {
        justificatifCarteIdentite.present = isConditionAcceptee;
      }
    },
    getSurclassementAcceptee(isConditionAcceptee) {
      let surclassement = _.find(this.listeJustificatifs, {
        type: "SURCLASSEMENT"
      });
      if (surclassement) {
        surclassement.present =
          isConditionAcceptee.isSameCertificatMedical ||
          isConditionAcceptee.isDocumentSurclassementLoaded;
      }
    },
    getJustificatifs(isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getJustificatifs(this.token_out, false /*mutation*/)
        .then(result => {
          that.listeJustificatifs = result.data;
          let justificatifQuestionnaireSante = _.find(that.listeJustificatifs, {
            type: "QUESTIONNAIRE_SANTE"
          });
          if (justificatifQuestionnaireSante) {
            that.isQuestionnaireSantePresent =
              justificatifQuestionnaireSante.present;
          }
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getJustificatifs,
            argsArray
          );
        });
    },
    formatDateFrancais(date) {
      // format date au format français dd/MM/yyyy (la date d'entrée est au format yyyy-MM-dd)
      return preinscriptionAppelsServeur.formatDateFrancais(date);
    },
    getAgeParDateCourante() {
      if (!this.preinscription_out.data) {
        return 0;
      }
      var dateNaissance = this.preinscription_out.data.dateNaissance;
      return preinscriptionAppelsServeur.getAgeLicencieParDateCourante(
        dateNaissance
      );
    }
  },
  created() {
    // la clone preinscription_out est utilisé dans le template et il faut l'initialiser avant mounted
    this.preinscription_out = JSON.parse(JSON.stringify(this.preinscription));

    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
  },
  mounted() {
    this.getJustificatifs(false /*isReconnected*/);
    this.$emit("can-continue", { value: false });
  }
};
</script>

<style scoped>
.mes-justificatifs {
  display: inline-flex;
  flex-flow: row wrap;
}

/* laptops & desktops */
@media (min-width: 1025px) {
  .mesJustificatifsPage {
    margin: 3rem 8rem;
  }
}

/* mobile phone */
@media (max-width: 480px) {
  .mesJustificatifsPage {
    margin: 10px 15px;
  }

  .mes-justificatifs {
    display: inline-grid;
  }
}

/* tablet */
@media (min-width: 481px) and (max-width: 1024px) {
  .mesJustificatifsPage {
    margin: 3rem 3rem;
  }
}
</style>
